<template>
  <v-menu
    v-model="isMenuOpened"
    content-class="mt-2 white"
    :offset-y="!isSubMenu"
    :offset-x="isSubMenu"
    :close-on-content-click="false"
  >
    <template #activator="{on, attrs}">
      <z-chip
        v-if="!isSubMenu"
        class="mr-1"
        x-small
        :close="value && value.length > 0"
        :selected="value && value.length > 0"
        :text="computedText"
        :icon="icon"
        :color="color"
        :icon-color="iconColor"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        @click:close="$emit('input', {id: id, value: []})"
      >
        <template #append-inner>
          <z-icon size="16" class="ml-1">$keyboard_arrow_down_rounded</z-icon>
        </template>
      </z-chip>

      <stop-list-group v-else>
        <v-list-item
          :input-value="subMenuSelectionStatus == true"
          :class="{
            'mb-1': true,
            'pa-0': configuration.eager,
            'px-4': !configuration.eager,
          }"
          v-on="on"
        >
          <v-list-item-action class="mr-1">
            <div class="d-flex align-center">
              <v-checkbox
                small
                class="ma-0"
                indeterminate-icon="$indeterminate_check_box_rounded"
                on-icon="$check_box_rounded"
                off-icon="$check_box_outline_blank_rounded"
                :indeterminate="subMenuSelectionStatus === 'indeterminate'"
                :color="color"
                :ripple="false"
                :input-value="subMenuSelectionStatus === true"
                @change="toggleValuesFromSubMenu"
              ></v-checkbox>

              <z-icon size="16" color="black">
                {{ icon }}
              </z-icon>
            </div>
          </v-list-item-action>

          <v-list-item-content :title="name">
            <v-list-item-title>
              {{ name }}
            </v-list-item-title>
          </v-list-item-content>

          <z-icon size="16" color="black">$keyboard_arrow_right</z-icon>
        </v-list-item>
      </stop-list-group>
    </template>

    <z-card width="auto" class="pa-0">
      <template #content>
        <div v-if="configuration.title" class="custom-title">
          {{ configuration.title }}
        </div>

        <v-list
          dense
          nav
          :class="{
            'px-0 pt-4 pb-2': !configuration.eager,
          }"
        >
          <div :style="{maxHeight: configuration.maxHeight}">
            <v-list-item-group
              :value="selectedValues"
              multiple
              @change="onChangeSelectedItens"
            >
              <stop-list-group v-if="configuration.toggleAll">
                <v-list-item
                  :input-value="toggleAllStatus === true"
                  :class="{
                    'px-4 mb-0': !configuration.eager,
                    'pa-0': configuration.eager,
                    'pr-2': isSubMenu,
                  }"
                  @click="
                    toggleAllValues(
                      hasAtLeastOneSelected ? true : !toggleAllStatus
                    )
                  "
                >
                  <v-list-item-action class="mr-1">
                    <div class="d-flex align-center">
                      <v-checkbox
                        small
                        class="ma-0"
                        indeterminate-icon="$indeterminate_check_box_rounded"
                        on-icon="$check_box_rounded"
                        off-icon="$check_box_outline_blank_rounded"
                        :indeterminate="toggleAllStatus === 'indeterminate'"
                        :color="color"
                        :ripple="false"
                        :input-value="toggleAllStatus === true"
                      ></v-checkbox>
                    </div>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        toggleAllStatus === true
                          ? $t('unselect_all')
                          : $t('select_all')
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider class="my-1"></v-divider>
              </stop-list-group>

              <template v-for="(item, index) in configuration.items">
                <multiple-type
                  v-if="item.children && item.children.length > 0"
                  :id="id"
                  :key="`sub-menu-${index}`"
                  :text="item.text"
                  :value="value"
                  :color="color"
                  :name="item.text"
                  :icon="item.icon"
                  :is-sub-menu="true"
                  :current-sub-menu="item"
                  :configuration="{
                    items: item.children,
                    eager: configuration.eager,
                    toggleAll: true,
                  }"
                  @input="$emit('input', $event)"
                ></multiple-type>

                <v-list-item
                  v-else
                  :key="`list-item-${index}`"
                  :value="item.value"
                  :class="{
                    'px-4 mb-0': !configuration.eager,
                    'pa-0': configuration.eager,
                    'pr-2': isSubMenu,
                  }"
                >
                  <template #default="{active}">
                    <v-list-item-action class="mr-1">
                      <div class="d-flex align-center">
                        <v-checkbox
                          small
                          class="ma-0"
                          on-icon="$check_box_rounded"
                          off-icon="$check_box_outline_blank_rounded"
                          :color="color"
                          :ripple="false"
                          :input-value="active"
                        ></v-checkbox>

                        <z-icon v-if="item.icon" color="black">
                          {{ item.icon }}
                        </z-icon>
                      </div>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.text }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </div>
        </v-list>

        <v-divider></v-divider>

        <div
          v-if="!configuration.eager"
          class="d-flex align-center justify-end px-4 pt-2 pb-4"
        >
          <z-btn
            rounded
            small
            class="mr-4"
            :text="$t('cancel')"
            :color="color"
            @click="isMenuOpened = false"
          ></z-btn>

          <z-btn
            primary
            rounded
            small
            dark
            :color="color"
            :text="$t('add')"
            @click="onAdd"
          ></z-btn>
        </div>
      </template>
    </z-card>
  </v-menu>
</template>

<script>
import StopListGroup from './components/StopListGroup.vue'

export default {
  name: 'MultipleType',
  components: {StopListGroup},
  props: {
    id: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    configuration: {
      type: Object,
      default: () => ({
        title: '',
        items: [],
        showValuesAsText: false,
        eager: false,
        toggleAll: false,
        maxHeight: '300px',
      }),
    },
    color: {
      type: String,
      default: 'var(--primary)',
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    //sub-menu
    name: {
      type: String,
      default: '',
    },
    isSubMenu: {
      type: Boolean,
      default: false,
    },
    currentSubMenu: {
      type: Object,
      default: () => ({}),
    },
    iconColor: {
      type: String,
      default: '',
    },
  },

  i18n: {
    messages: {
      pt: {
        cancel: 'Cancelar',
        add: 'Adicionar',
        select_all: 'Selecionar todos',
        unselect_all: 'Desmarcar todos',
      },

      en: {
        cancel: 'Cancel',
        add: 'Add',
        select_all: 'Select all',
        unselect_all: 'Unselect all',
      },

      es: {
        cancel: 'Cancelar',
        add: 'Agregar',
        select_all: 'Seleccionar todos',
        unselect_all: 'Deseleccionar todos',
      },
      fr: {
        cancel: 'Annuler',
        add: 'Ajouter',
        select_all: 'Tout sélectionner',
        unselect_all: 'Tout désélectionner',
      },
      tr: {
        cancel: 'İptal',
        add: 'Ekle',
        select_all: 'Tümünü seç',
        unselect_all: 'Tümünü kaldir',
      },
    },
  },

  data() {
    return {
      isMenuOpened: false,
      selectedValues: [],
    }
  },

  computed: {
    computedText() {
      const allItems = this.flattenItems(this.configuration?.items || [])

      if (!this.value?.length) return this.text

      return this.configuration?.showValuesAsText
        ? allItems
            .filter((item) => this.value.includes(item.value))
            .map((item) => item.text)
            .join(', ')
        : this.text
    },

    subMenuSelectionStatus() {
      const submenuItems = this.currentSubMenu.children
      const selectedItems = submenuItems.filter((child) =>
        this.value.includes(child.value)
      )

      if (selectedItems.length === 0) {
        return false
      } else if (selectedItems.length === submenuItems.length) {
        return true
      } else {
        return 'indeterminate'
      }
    },

    toggleAllStatus() {
      if (this.isSubMenu) {
        const totalItems = this.configuration.items.length
        const selectedItemCount = this.configuration.items.filter((item) =>
          this.value.includes(item.value)
        ).length

        if (selectedItemCount === 0) {
          return false
        } else if (selectedItemCount === totalItems) {
          return true
        } else {
          return 'indeterminate'
        }
      } else {
        const totalItems = this.flattenItems(
          this.configuration?.items || []
        ).filter((item) => item.value).length

        const selectedItemCount = this.selectedValues.length

        if (selectedItemCount === 0) {
          return false
        } else if (selectedItemCount === totalItems) {
          return true
        } else {
          return 'indeterminate'
        }
      }
    },

    hasAtLeastOneSelected() {
      const totalItems = this.flattenItems(
        this.configuration?.items || []
      ).filter((item) => item.value).length

      return (
        this.selectedValues.length > 0 &&
        this.selectedValues.length < totalItems
      )
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedValues = newVal
      },
    },

    isMenuOpened() {
      this.selectedValues = this.value
    },
  },

  methods: {
    flattenItems(items) {
      return items.reduce((acc, item) => {
        acc.push(item)
        if (item.children) {
          acc.push(...this.flattenItems(item.children))
        }
        return acc
      }, [])
    },

    onAdd() {
      this.$emit('input', {id: this.id, value: this.selectedValues})
      this.isMenuOpened = false
    },

    toggleAllValues(e) {
      if (this.isSubMenu) {
        const valuesFromSubMenu = this.configuration.items.map(
          (item) => item.value
        )
        let newValues
        if (e) {
          newValues = [...new Set([...this.value, ...valuesFromSubMenu])]
        } else {
          newValues = this.value.filter(
            (value) => !valuesFromSubMenu.includes(value)
          )
        }
        this.onChangeSelectedItens(newValues)
      } else {
        const allValues = this.flattenItems(this.configuration?.items || [])
          .filter((item) => item.value)
          .map((item) => item.value)
        this.onChangeSelectedItens(e ? allValues : [])
      }
    },

    toggleValuesFromSubMenu(e) {
      const valuesFromSubMenu = this.currentSubMenu.children.map(
        (child) => child.value
      )

      let newValues
      if (e) {
        newValues = [...this.value, ...valuesFromSubMenu]
      } else {
        newValues = this.value.filter(
          (value) => !valuesFromSubMenu.includes(value)
        )
      }

      this.onChangeSelectedItens(newValues)
    },

    onChangeSelectedItens(e) {
      this.selectedValues = e

      if (this.configuration.eager) {
        this.$emit('input', {id: this.id, value: e})
      }
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-chip__close) {
  font-size: 12px !important;
}

:deep(.v-list-item) {
  min-height: 24px !important;
  height: 24px !important;

  &::before {
    border-radius: 0px;
  }
}

:deep(i) {
  font-size: 16px !important;
}

.custom-title {
  /* Body/Default Title Case */
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 18px */
  text-transform: capitalize;
}

* {
  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px !important;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--black-100);
    border-radius: 10px !important;
  }
}
</style>
